import * as React from 'react';

import FullStorySnippet from '@/lib/fullstory-script';
import { useGlobalContext } from '@/hooks/use-global-context';

import Footer from '@/components/layout/footer';
import PageHead from '@/components/layout/head';
import Header from '@/components/layout/header';
import PreviewAlert from '@/components/preview-alert';
import { HygraphScript } from '@/components/renderers/script';

type DefaultLayoutProps = {
  preview?: boolean;
  children: React.ReactNode;
  hideFooter?: boolean;
};

export default function DefaultLayout({
  preview,
  children,
  hideFooter,
}: DefaultLayoutProps) {
  const { pageMeta } = useGlobalContext();
  const scripts = pageMeta.templateSetting?.scripts ?? [];

  return (
    <div className='relative flex min-h-screen flex-col overflow-hidden'>
      {scripts.map((script) => (
        <HygraphScript key={script.id || script.slug} {...script} />
      ))}
      <FullStorySnippet />
      <PreviewAlert preview={preview} />
      <PageHead />
      <Header />
      {children}

      {!hideFooter && <Footer />}
    </div>
  );
}
